export default "__VITE_ASSET__D0qFKNKA__"